import {useIntl} from 'react-intl'
import {CrudProvider} from '../../../services/loggedin/CrudContext'
import {ChartsComponent} from '../../parts/crud/Charts'
import {getBaseBarChartOptions} from '../../parts/crud/Types'
import {useState} from 'react'
import moment from 'moment'

import {DataRangeFilter} from '../../parts/filters/DataRangeFilter'
import {TimeDimensionGroupFilter} from '../../parts/filters/TimeDimensionGroupFilter'
import {ServerFilter} from '../../parts/filters/ServerFilter'
import {EventCategoryFilter} from '../../parts/filters/EventCategoryFilter'

export const EventsNeverClosed = () => {
  const intl = useIntl()
  const [filterData, setFilterData] = useState<any>(null)
  const [dateRange, setDateRange] = useState({
    start: moment().subtract(6, 'days'),
    end: moment(),
  })

  let params: any = {
    intl,
    title: intl.formatMessage({id: 'OPERATION_RANKING.EVENTS_NEVER_CLOSED_TITLE'}),
    subtitle: intl.formatMessage({id: 'OPERATION_RANKING.EVENTS_NEVER_CLOSED_SUBTITLE'}),
    yAxisTitle: intl.formatMessage({id: 'OPERATION_RANKING.USER_MANAGED_EVENTS.Y_AXIS'}),
    headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
    pointFormat: '<tr><td style="color:{series.color};padding:0">12{series.name}: </td>' +
      '<td style="padding:0"><b>{point.y:.0f} </b></td></tr>',
    footerFormat: '</table>',
    useHTML: true,
    shared: true,
  }
  let baseChartOptions: any = {...getBaseBarChartOptions(params)}
  baseChartOptions.plotOptions = {
    column: {
      pointPadding: 0.2,
      borderWidth: 0,
      minPointLength: 8,
    },
    area: {
      fillOpacity: 0.5,
    },
  }
  baseChartOptions.legend =  {
    //layout: 'horizontal',
    align: 'center',
    //verticalAlign: 'top',
    //x: 150,
    //y: 100,
    //floating: false,
    //draggable: true,
    borderWidth: 1,
    backgroundColor: '#FFFFFF',
    title: {
        text: ':: Events categories' 
    },
    
  };
  baseChartOptions.chart.type = 'column'
  baseChartOptions.chart.zoomType = 'x'
  baseChartOptions.chart.spacingBottom = 30;
  baseChartOptions.drilldown = [];
  const [loading, setLoading] = useState(false)
  
  const [grouping, setGrouping] = useState<string>('0')
  const [groupingOptionSelected, setGroupingOptionSelected] = useState<any>()
  const [server, setServer] = useState('all')
  const [serversSelected, setServersSelected] = useState<any>([])
  const [error, setError] = useState('')
  const [categorySelected, setCategorySelected] = useState<any>(null)
  const [eventCategory, setEventCategory] = useState<any>(null)
  const [error_category, setErrorCategory] = useState('')
  const [group_selected, setGroupSelected] = useState<any>(null)
  const submitData = async () => {
    let has_error = false
    setError('')
    if (
      server === 'oneormore' &&
      (serversSelected === null || (Array.isArray(serversSelected) && serversSelected.length === 0))
    ) {
      setError(intl.formatMessage({id: 'GENERIC.REQUIRED:SELECT_SERVER'}))
      has_error = true
    }
    setErrorCategory('')
    if (
      eventCategory === '0' &&
      (categorySelected === null ||
        (Array.isArray(categorySelected) && categorySelected.length === 0))
    ) {
      setErrorCategory(intl.formatMessage({id: 'GENERIC.REQUIRED:SELECT_CATEGORY'}))
      has_error = true
    }
    if (has_error) {
      return
    }

    let data: any = {
      date_range: {
        start: dateRange.start.format('YYYY-MM-DD') + ' 00:00:00',
        end: dateRange.end.format('YYYY-MM-DD') + ' 23:59:59',
      },
      tz: new Date().getTimezoneOffset(),
      grouping: grouping,
      group_dimension: groupingOptionSelected ? groupingOptionSelected.value : null,
      server: server,
      group_list: group_selected ? group_selected.value : null,
      selected_server: serversSelected ? serversSelected.map((srv: any) => srv.value) : [],
      eventcat_selected:
        eventCategory === '0' && categorySelected
          ? categorySelected.map((cat: any) => cat.value)
          : [],
    }
    setFilterData(data)
  }

  return (
    <>
      <CrudProvider api='operation-ranking/events-never-closed'>
        <ChartsComponent setLoading={(loading)=>{
          setLoading(loading)
        }} filterData={filterData} baseChartOptions={baseChartOptions}>
          <p>{intl.formatMessage({id: 'OPERATION_RANKING.EVENTS_NEVER_CLOSED.TEXT'})}</p>

          <DataRangeFilter
            onChangedDataRange={(start, end) => {
              setDateRange({
                start: start,
                end: end,
              })
            }}
          />
          <TimeDimensionGroupFilter
            onChangedGrouping={(grouping) => {
              setGrouping(grouping)
            }}
            onChangedGroupingOption={(groupingOptionSelected) => {
              setGroupingOptionSelected(groupingOptionSelected)
            }}
          />

          <ServerFilter
            onChangedServer={(server) => {
              setServer(server)
            }}
            onChangedServersSelected={(servers) => {
              setServersSelected(servers)
            }}
            onGroupSelected={(group) => {
              setGroupSelected(group)
            }}
          />

          {error && <div className='alert alert-danger'>{error}</div>}

          <EventCategoryFilter
            onChangedEventCategory={(eventCategory: any) => {
              setEventCategory(eventCategory)
            }}
            onChangedCategorySelected={(categorySelected: any) => {
              setCategorySelected(categorySelected)
            }}
          />
          {error_category && <div className='alert alert-danger'>{error_category}</div>}
          <input
            type='button'
            disabled={loading}
            className='btn btn-primary'
            onClick={submitData}
            value={intl.formatMessage({id: 'GENERIC.SUBMIT'})}
            style={{float:"left"}}
          />{' '}
          {loading && <div className='spinner-border text-primary' role='status' style={{marginTop: '7px',float:"left",marginLeft:"10px"}}>
                <span className='visually-hidden'>Loading...</span>
              </div>}
        </ChartsComponent>
      </CrudProvider>
    </>
  )
}
